import { where } from "firebase/firestore";
import { useCollection } from "@/lib/hooks/useCollection";
import type { ContactSubmission } from "./lifecycle";

// Module-level so the hook's subscription key is stable across renders.
const UNANSWERED = [where("status", "==", "new")] as const;

/**
 * How many enquiries nobody has dealt with.
 *
 * Live, so the number in the menu is never stale, and read as a query for the
 * unanswered rows only — the menu does not need the answered ones, and a
 * console that pulls a whole collection to show a count is a console that
 * gets slower with every enquiry it ever received.
 */
export function useUnansweredCount(): number {
  const { rows } = useCollection<ContactSubmission>("contactSubmissions", UNANSWERED);
  return rows.length;
}
